import { Input } from "antd";
import React, { useState } from "react";
import { apiCall } from "../utils/Api";
import { filterUnique, sortAlpha } from "../utils/Utils";

export default function FilterAutocomplete(props) {

    const { searchFilters = {}, filters = [], setFilters, name = "", facet_row_counts = {} } = props;
    const [initFilters, setInitFilters] = useState([]);

    const local = (name === "publisher_imprint") ? false : true;


    const hasChild = (_item) => {
        return (_item?.subfilter && _item.subfilter.length > 0)
    }


    const rows = filters.find(f => f.name === name)?.rows ?? [];



    const searchLocal = (_search, ifilters) => {

        if (!_search) {
            setFilters(ifilters);
            return;
        }

        let index = ifilters.findIndex(item => item.name === name);

        if (index > -1) {
            let _f = ifilters.map(item => {
                return { ...item }
            });

            _f[index].rows = _f[index].rows.map(t => {
                let u = { ...t };
                u.subfilter = t.subfilter ? [...t.subfilter] : "";
                const parentMatch = u.name.toUpperCase().includes(_search.toUpperCase());
                if (u.subfilter && !parentMatch) {
                    u.subfilter = u.subfilter.filter(i =>
                        i.name.toUpperCase().includes(_search.toUpperCase())
                    );
                }
                return u;
            });

            _f[index].rows = sortAlpha(filterUnique(_f[index].rows.filter(item => item.name.toUpperCase().includes(_search.toUpperCase()) || hasChild(item) && item.key !== "--"), "name"), "name")
            setFilters(_f);
        }


    }

    const onChange = (_search) => {

        let ifilters = initFilters;
        if (filters.length > initFilters.length) {
            ifilters = filters.map(item => ({
                ...item,
                rows: item.rows.map(row => ({
                    ...row,
                    subfilter: row.subfilter ? [...row.subfilter] : undefined
                }))
            }));
            setInitFilters(ifilters);
        }

        if (!_search) {
            setFilters(ifilters);
            setInitFilters([]);
        }

        if (local) {
            return searchLocal(_search, ifilters);
        }


        apiCall("browse/getAutocompleteFacets", { filter_name: "publisher_imprint", search_term: _search, search_filters: JSON.stringify(searchFilters) }, (_status, _result) => {
            if (_status) {
                let index = ifilters.findIndex(item => item.name === name);
                if (index > -1) {
                    let _f = [...ifilters]
                    _f[index].rows = _result.rows;
                    setFilters(_f);
                }

            }
        })
    }


    const fetchLots = () => {
        apiCall("browse/getAutocompleteFacets", { filter_name: "publisher_imprint", search_term: "", limit: 500, search_filters: JSON.stringify(searchFilters) }, (_status, _result) => {
            if (_status) {

                let index = filters.findIndex(item => item.name === name);
                if (index > -1) {
                    let _f = [...filters];
                    _f[index].rows = _result.rows;
                    setFilters(_f)
                }



            }
        })
    }

    const { publisher_imprint = 0 } = facet_row_counts;


    return (
        <>
            <div className="shim" />
            <Input onChange={(e) => onChange(e.target.value)} allowClear onKeyDown={(e) => {
                if (e.key === "Enter") {
                    // onChange(e.target.value);
                }
            }} style={{ "fontSize": "12px" }} size="small" placeholder="Refine..." />

            <div className="shim" />

            {(!local && initFilters.length === 0 && publisher_imprint > 0 && rows.length !== 500 && publisher_imprint > rows.length && <>
                <div className="float-flex">
                    <div className="c"><small>Showing {rows.length} of {(publisher_imprint > 5000) ? "thousands" : publisher_imprint}</small></div>
                    <div className="c"><small><a onClick={() => fetchLots()}>{(publisher_imprint > 501) ? "Load 500" : "Load all " + publisher_imprint}</a></small></div>
                </div>
            </>)}



        </>
    )
}